import { Component, Input } from '@angular/core';

@Component({
    selector: 'sgt-representante-form-input-disabled',
    templateUrl: 'representante-form-input-disabled.component.html',
    styleUrls: ['./representante-form-input-disabled.component.less']
})
export class RepresentanteFormInputDisabledComponent {
    @Input() codigoIntegracaoErp: string;
    @Input() cnpjCpf: string;
    @Input() nome: string;
    @Input() nomeFantasia: string;
}

